import * as CONSTANTS from 'common/constants/analyst-dashboards';
import { MODELS_COLUMN_IDS, MODELS_COLUMN_LABELS } from './constants';

const col = (id: string, label: string) => ({
  id,
  label,
  isSortable: true,
  align: 'left' as const,
  disablePadding: false,
});

export const valuationsColumns = [
  col(CONSTANTS.COMPANY_NAME_KEY, CONSTANTS.COMPANY_NAME),
  col(CONSTANTS.STATUS_KEY, CONSTANTS.STATUS),
  col(CONSTANTS.DEAL_NAME_KEY, CONSTANTS.DEAL_NAME),
  col(CONSTANTS.NOTES_KEY, CONSTANTS.NOTES),
  col(CONSTANTS.OTHER_CONSULTANT_KEY, CONSTANTS.OTHER_CONSULTANT),
  col(CONSTANTS.ENGAGEMENT_MANAGER_KEY, CONSTANTS.ENGAGEMENT_MANAGER),
  col(CONSTANTS.VALUATION_DATE_KEY, CONSTANTS.VALUATION_DATE),
  col(CONSTANTS.CREATED_AT_KEY, CONSTANTS.CREATED_AT),
  col(CONSTANTS.VALUATION_FEE_KEY, CONSTANTS.VALUATION_FEE),
  col(CONSTANTS.DUE_KEY, CONSTANTS.DUE),
  col(CONSTANTS.SUPPORTING_DUE_DATE_KEY, CONSTANTS.SUPPORTING_DUE_DATE),
  col(CONSTANTS.DEAL_KEY, CONSTANTS.DEAL),
  col(CONSTANTS.DEAL_DUE_KEY, CONSTANTS.DEAL_DUE),
  col(CONSTANTS.DEAL_STAGE_KEY, CONSTANTS.DEAL_STAGE),
  col(CONSTANTS.NET_VALUE_KEY, CONSTANTS.NET_VALUE),
  col(CONSTANTS.SPLIT_KEY, CONSTANTS.SPLIT),
  col(CONSTANTS.PAYMENT_1_KEY, CONSTANTS.PAYMENT_1),
  col(CONSTANTS.PAY_1_DATE_KEY, CONSTANTS.PAY_1_DATE),
  col(CONSTANTS.PAYMENT_2_KEY, CONSTANTS.PAYMENT_2),
  col(CONSTANTS.PAY_2_DATE_KEY, CONSTANTS.PAY_2_DATE),
  col(CONSTANTS.PAYMENT_3_KEY, CONSTANTS.PAYMENT_3),
  col(CONSTANTS.PAY_3_DATE_KEY, CONSTANTS.PAY_3_DATE),
  col(CONSTANTS.REFUND_KEY, CONSTANTS.REFUND),
  col(CONSTANTS.REFUND_DATE_KEY, CONSTANTS.REFUND_DATE),
  col(CONSTANTS.ADJUSTMENT_KEY, CONSTANTS.ADJUSTMENT),
  col(CONSTANTS.ADJUSTMENT_DATE_KEY, CONSTANTS.ADJUSTMENT_DATE),
  col(CONSTANTS.BAD_DEBT_KEY, CONSTANTS.BAD_DEBT),
  col(CONSTANTS.BAD_DEBT_DATE_KEY, CONSTANTS.BAD_DEBT_DATE),
  col(CONSTANTS.RENEWAL_RATE_KEY, CONSTANTS.RENEWAL_RATE),
];

export const modelsColumns = [
  col(MODELS_COLUMN_IDS.COMPANY_NAME, MODELS_COLUMN_LABELS.COMPANY_NAME),
  col(MODELS_COLUMN_IDS.VALUATION_STATUS, MODELS_COLUMN_LABELS.VALUATION_STATUS),
  col(MODELS_COLUMN_IDS.MODEL_STATUS, MODELS_COLUMN_LABELS.MODEL_STATUS),
  col(MODELS_COLUMN_IDS.SUPPORTING_DUE_DATE, MODELS_COLUMN_LABELS.SUPPORTING_DUE_DATE),
  col(MODELS_COLUMN_IDS.NOTES, MODELS_COLUMN_LABELS.NOTES),
  col(MODELS_COLUMN_IDS.MODEL_REVIEWER, MODELS_COLUMN_LABELS.MODEL_REVIEWER),
  col(MODELS_COLUMN_IDS.MODEL_PREPARER, MODELS_COLUMN_LABELS.MODEL_PREPARER),
  col(MODELS_COLUMN_IDS.VALUATION_LEAD, MODELS_COLUMN_LABELS.VALUATION_LEAD),
  col(MODELS_COLUMN_IDS.VALUATION_DATE, MODELS_COLUMN_LABELS.VALUATION_DATE),
];